import { styled } from '@mui/material';

export const StyledAddToDoItemWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	cursor: 'pointer',
});

export const StyledAddToDoTemTextFieldWrap = styled('div')({
	'& input': {
		height: 'auto',
		padding: '7px',
	},
});
